import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Zpět',
      changePassword: 'Změnit heslo',
      copiedVaultId: 'Zkopírováno!',
      copyVaultID: 'Zkopírujte ID Vault',
      create: 'Vytvořit',
      next: 'Další',
      notSure: 'Nevím to jistě',
      signUp: 'Přihlásit se',
      submit: 'Podat',
      updatePassword: 'Aktualizovat heslo',
    },
    Errors: {
      createReportFailed: 'Vytváření záznamu se nezdařilo.',
    },
    ReportStatus: {
      CLOSED: 'Uzavřeno',
      INVESTIGATING: 'Ve vyšetřování',
      NEW: 'Podáno',
      READ: 'Přečteno',
    },
    general: {
      navbar: {
        caseSettings: 'Nastavení případu',
        changePassword: 'Změnit heslo',
        logOut: 'Odhlásit se',
        notifications: 'Oznámení',
        notificationsDrawer: {
          appFileScanFailed: 'Soubor neprošel bezpečnostní kontrolou',
          appReportMatch: 'Váš záznam GoTogether byl spárován',
          appReportReassigned: 'Byl přidělen nový manažer případů.',
          case: 'Případ',
          caseAssigned: 'Případ vám byl přiřazen',
          caseImporterJobCompleted: {
            PartialSuccess: 'Import vašeho případu byl dokončen s chybami',
            failure: 'Import vašeho případu selhal',
            success: 'Váš import případu byl úspěšně dokončen',
          },
          caseLinked: 'Případ spojený',
          caseTeamInvite: 'Přidáno do případu',
          caseUnlinked: 'Případ odpojen',
          dataSanitisation: 'Podrobnosti zprávy aktualizovány',
          emptyDescription: 'Vraťte se později pro nové oznámení',
          emptyTitle: 'Jste v obraze',
          importId: 'Importovat ID:',
          learnMore: 'Dozvědět se více',
          markAllAsRead: 'Označit vše jako přečtené',
          newMessage: 'Nová zpráva',
          newReport: 'Nová zpráva přijata',
          permissionRemoved: 'Odstraněno z případu',
          postSSubmissionFile: 'Přidán(y) důkazní soubor(y)',
          report: 'Zpráva',
          reportAssigned: 'Zpráva přiřazena vám',
          reportStatusChange: 'Stav zprávy se změnil',
          reporterAnonymised: 'Vaše údaje byly anonymizovány',
          reporterReportSubmitted: {
            subtitle: 'Doporučujeme si uložit kopii vaší zprávy',
            title: 'Podaná zpráva',
          },
          mitigationPlanReminder: 'Vyžaduje se schválení plánu zmírnění',
          staleCase: 'Nevyřešený případ',
        },
        privacyStatement: 'Prohlášení o ochraně soukromí',
        reporter: {
          myReports: 'Moje zprávy',
        },
        settings: 'Nastavení',
        technicalSupport: 'Technická podpora',
        title: 'Účet',
      },
      time: {
        day: 'Den',
        days: 'Dny',
        hour: 'Hodina',
        hours: 'Hodiny',
        minute: 'Minuta',
        minutes: 'Minuty',
        second: 'Druhý',
        seconds: 'Sekundy',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonymní',
        autoTranslate: 'Auto-překlad je ve výchozím nastavení vypnutý.',
        backToMessages: 'Zpět na zprávy',
        caseSettings: 'Nastavení případu.',
        changeInProfile:
          'Pokud si přejete toto nastavení změnit, můžete tak učinit ve svém profilu.',
        deletedByMessage: 'Smazáno uživatelem {{author}}',
        deletedMessageLabel: 'Tato zpráva byla smazána',
        description:
          'Když je zapnuto automatické překládání, všechny zprávy z hlášení budou\n          automaticky přeloženy pomocí AI na základě výchozího jazyka\n          vybraného na vašem prohlížeči.',
        descriptionSecondHalf:
          'Původní verze všech zpráv je vždy zachována a lze ji najít v chatu.',
        messagePlaceholder: 'Začněte psát...',
        messageSettings: 'Nastavení zpráv.',
        originalMessages: 'Původní',
        showMoreBanner: 'Dozvědět se více o automatických překladech',
        titlev2: 'Přečtěte si všechny zprávy ve svém preferovaném jazyce.',
        translatedMessageLabel: 'Přeložená zpráva',
        translatedMessages: 'Přeloženo',
        understood: 'Rozumím',
      },
      Country: {
        description: 'Ve které zemi pracujete?',
        header: 'Ve které zemi pracujete?',
        noOptions: 'Žádné země nenalezeny',
        other: 'Jiné',
        placeholder: 'Hledejte zemi...',
      },
      CreatePublicReport: {
        createReport: 'Vytvořit nový záznam',
        helpPage: 'Přejděte na naši stránku s pomocí',
        loginToOpr: 'Přihlaste se k sledování zpráv',
        or: 'nebo',
        passwordPlaceholder: 'Zadejte heslo',
        phoneNumberLoginFailed:
          'Přihlášení se nezdařilo, telefonní číslo / pin je nesprávné',
        phoneNumberPlaceholder: 'Zadejte své telefonní číslo',
        phoneNumberTooltip:
          'Zadejte telefonní číslo, které jste použili k kontaktování VaultTalk.',
        pinPlaceholder: 'Zadejte PIN',
        reportIntroductionParagraph1:
          'Při hlášení incidentu se vás zeptáme na několik otázek, které vám pomohou zdokumentovat vaši zkušenost.',
        reportIntroductionParagraph2:
          'Před odesláním máte možnost zůstat anonymní k ochraně svého soukromí.',
        reportIntroductionParagraph3:
          'Po odeslání se můžete kdykoli přihlásit a sledovat průběh vaší zprávy a mluvit s manažerem případu.',
        reportIssue: 'Nahlásit problém',
        usernameLoginFailed:
          'Přihlášení se nezdařilo, uživatelské jméno / heslo je nesprávné',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Je vyžadován vztah k firmě.',
            reportedCategoryRequired: 'Požadovaná kategorie je povinná',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Zadejte svůj e-mail nebo ID Vault',
        vaultIdTooltip:
          'Pro anonymní hlášení je ID Vault alfanumerické. Pokud hlášení nebylo anonymní, je vaše ID Vault vaše e-mailová adresa.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Vaše heslo',
        yourPhoneNumber: 'Vaše telefonní číslo',
        yourPin: 'Váš šestimístný PIN',
        yourVaultId: 'Vaše ID Vault',
      },
      CustomHeader: {
        companyLogo: 'Firemní logo',
        openReporting: 'Otevřít nahlašování',
        userSettings: 'Uživatelská nastavení',
      },
      Date: {
        approximateDescription:
          'Pamatujete si přibližné datum, kdy k události došlo?',
        approximatePlaceholder:
          'Příklad: před 6 měsíci / loni / loni v listopadu',
        cancel: 'zrušit',
        clear: 'vymazat',
        description: 'Pamatujete si datum, kdy k události došlo?',
        header: 'Který den k ní došlo?',
        ok: 'ok',
        placeholder: 'Příklad: 21. června 2020',
      },
      Description: {
        whatHappened: 'Co se stalo?',
        whatHappenedPlaceholder: 'Použijte vlastní slova…',
        whatHappenedText: 'Popište vlastními slovy, co se stalo',
      },
      Details: {
        disclaimer:
          'Tyto podrobnosti budou zveřejněny s vaší zprávou. Pokud si přejete zůstat anonymní, ujistěte se, že neobsahují identifikační informace.',
        emailPlaceholder: 'E-mail (volitelný)',
        fullNamePlaceholder: 'Celé jméno (volitelné)',
        header: 'Vaše údaje',
        nonAnonSubtitle:
          'Prosím, uveďte buď vaše jméno nebo e-mailovou adresu. Pokud chcete dostávat oznámení o této zprávě, přidejte níže příslušnou e-mailovou adresu.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Celé jméno',
        subtitle:
          'Pokud chcete dostávat upozornění na tento report, přidejte níže vhodnou e-mailovou adresu.',
      },
      Emotion: {
        description: 'Jak jste se cítili? Jaký to mělo dopad?',
        header: 'Jaký to mělo dopad?',
        placeholder: 'Začněte psát…',
      },
      Evidence: {
        addedHeading: 'Přidáno',
        deletedMessage: 'byl smazán',
        deletedStatus: 'Smazáno',
        failedToOpenFileMessage:
          'Otevření souboru selhalo. Prosím, zkuste to znovu.',
        fileStatuses: {
          infectedUpload: 'Označeno bezpečnostní kontrolou',
          passedUpload: 'Prošel bezpečnostní kontrolou',
          pendingUpload: 'Probíhá bezpečnostní kontrola',
          readyForDownload: 'Připraveno ke stažení',
        },
        mobileErrorMessage:
          'Označené soubory: napište svému případovému manažerovi',
        nameHeading: 'Jméno',
        statusHeading: 'Stav',
        tableTitle: 'Důkaz',
        webErrorMessage:
          'Označené soubory: Pokud byly vaše soubor(y) označeny, prosím, zašlete zprávu správci případu.',
      },
      FileUpload: {
        addFiles: 'Přidat soubory',
        addMoreFiles: 'Přidejte další soubory',
        confirm: 'Potvrďte',
        description:
          'Přidání souborů jako důkaz může podpořit efektivitu řešení vaším správcem případu. Prosím zvažte obsah souboru (včetně metadat souboru), pokud si přejete zůstat anonymní, a respektujte práva ostatních jedinců a platné zákony.',
        dragDrop: 'Sem přetáhněte soubory nebo',
        errorMessage:
          'Soubor(y) selhal(y) kvůli chybě v síti. Klikněte níže, abyste zaslali zprávu svému správci případů pro pomoc.',
        fileLimit: 'Omezení velikosti každého souboru: 100MB',
        fileUploadLimitText: 'Můžete nahrát pouze 10 souborů',
        header: 'Přidat důkaz',
        helpArticle: 'nápovědný článek',
        highlighted: 'procházet soubory',
        information: 'Podporované typy souborů',
        moreInformation:
          'Pro více informací, prosím podívejte se na to <a>nápovědný článek</a>',
        postSubmissionErrorMessage:
          "Nemohli jsme nahrát vaše soubory kvůli systémové chybě. Prosím, vyberte znovu 'potvrdit'.",
        tooltipAudio: 'Zvuk:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenty:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Obrázky:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Soubor je příliš velký',
          invalidFileType: 'Nepodporovaný typ souboru: {{extension}}',
          systemError: 'Chyba systému',
          tooManyFiles: 'Maximální počet souborů je {{maxFiles}}',
        },
        uploadFiles: 'Nahrát soubory',
      },
      Loading: {
        loading:
          'Prosím počkejte, zatímco odesíláme vaši zprávu k případovému manažerovi...',
        postSubmissionLoading:
          'Prosím počkejte, zatímco odesíláme vaše soubor(y)...',
      },
      Location: {
        description: 'Kde k ní došlo?',
        header: 'Kde k ní došlo?',
        placeholder: 'Příklad: v kanceláři',
      },
      MessageListBox: {
        messageCaseManager: 'Napsat manažerovi případu',
        report: 'Hlášení {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Překlad zakázán',
        enableTranslationLabelEnabled: 'Překlad povolen',
        enableTranslationsDescription:
          'Povolte automatické překlady a čtěte všechny zprávy z reportů ve svém preferovaném jazyce. Přeložený jazyk je založen na jazyku vybraném na vašem zařízení.',
        enableTranslationsHeader:
          'Povolit automatické překlady pro zprávy o hlášeních',
        enableTranslationsSubDescriptionv2:
          'Můžete přepínat mezi přeloženým a původním jazykem v každém chatu.',
        updateTranslationFailed: 'Aktualizace překladu selhala',
        updateTranslationSuccess:
          'Nastavení překladu bylo úspěšně aktualizováno',
      },
      Password: {
        changePasswordHeader: 'Změnit heslo',
        createNewPassword: 'Vytvořte si nové heslo',
        createPasswordHeader: 'Vaše heslo',
        currentPasswordPlaceholder: 'Zadejte aktuální heslo',
        description:
          'Platné heslo musí mít alespoň 9 znaků a musí obsahovat jedno velké písmeno a jedno číslo',
        enterCurrentPassword: 'Zadejte aktuální heslo',
        forgottenPasswordInstructions:
          'Zadejte své alfanumerické ID Vault (ne vaši e-mailovou adresu) a e-mailovou adresu pro resetování vašeho hesla.',
        newDescription:
          'Vytvořte silné heslo pro zabezpečení vašeho účtu. Začněte psát a pod ním se zobrazí pokyny.',
        passwordPlaceholder: 'Vytvořte si heslo',
        passwordResetRequestedDescription:
          'Pokud váš Vault ID existuje v našem systému, obdržíte e-mail s instrukcemi pro obnovení hesla.',
        passwordResetRequestedHeader: 'Požadován odkaz pro resetování hesla',
        reenterPlaceholder: 'Znovu zadejte heslo',
        subtitle:
          'Vytvořte si heslo, ať můžete hlášení odeslat a později se k němu znovu přihlásit',
        yourVaultId: 'Vaše ID Vault',
        yourVaultIdPlaceholder: 'Zadejte své Vault ID (např. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Nahlašujete konkrétní osobu nebo více lidí? Můžete je jmenovat nebo popsat?',
        header: 'Zúčastněné osoby',
        placeholder:
          'Začnete psát a jednotlivá jména nebo popisy oddělujte čárkou',
      },
      PoweredByVault: 'Od společnosti {{company}}',
      PrivacyStatement: 'Prohlášení o ochraně soukromí produktu',
      PublicMessageList: {
        myMessages: 'Moje zprávy',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Důkazy přidány k existující zprávě',
        backToReportId: 'Zpět na hlášení ID: {{reportId}}',
        description:
          'Přidání souborů jako důkaz může podpořit efektivitu řešení vašeho případu správcem. Prosím zvažte obsah souboru (včetně metadat souboru), pokud si přejete zůstat anonymní a respektujte práva ostatních jedinců a platné zákony. Pro více informací prosím navštivte toto <a>nápovědný článek</a>',
        header: 'Přidejte další důkazy do zprávy',
        vaultTalkOpenCaseHeader: 'Přidejte důkazy do své zprávy',
      },
      PublicReport: {
        anonymous: 'Anonymní',
        backToReports: 'Zpět na hlášení',
        skipped: 'Přeskočeno',
      },
      PublicReportCard: {
        addEvidence: 'Přidejte další důkazy',
        messageCaseManager: 'Napsat manažerovi případu',
        reportId: 'ID hlášení:',
        submitted: 'Podáno',
        vaultTalkClosedCaseCTA: 'Zobrazit důkazy',
        vaultTalkOpenCaseCTA: 'Přidat důkaz',
        viewAdditionalEvidence: 'Zobrazit další důkazy',
        viewReport: 'Zobrazit hlášení',
      },
      PublicReportsList: {
        reportingSystem: 'Ohlašovací systém',
      },
      Question: {
        placeholder: 'Začněte psát...',
        question: 'Poskytněte podrobnosti',
        questionText: 'Sdílejte s námi svůj dotaz, aktualizaci nebo poptávku.',
      },
      Relationship: {
        header: 'Váš vztah k organizaci',
        tellUsAbout: 'Popište svůj vztah k organizaci.',
      },
      ResponsiveNavMenu: {
        messages: 'Moje zprávy',
        reports: 'Moje zprávy',
      },
      Site: {
        description: 'Na kterém pracovišti pracujete?',
        header: 'Na kterém pracovišti pracujete?',
        noOptions: 'Žádná pracoviště nenalezena',
        other: 'Jiné',
        placeholder: 'Hledejte pracoviště...',
      },
      SpamPuzzle: {
        dialog: 'Vyřešte skládačku a pokračujte',
      },
      SubmissionTypes: {
        reportIssue: 'Vyberte kategorii',
        whatType: 'Vyberte kategorii, která nejlépe popisuje vaši zprávu',
      },
      SubmitSuccess: {
        category: '<bold>Kategorie:</bold> {{category}}',
        country: '<bold>Země:</bold> {{country}}',
        dateSubmitted: '<bold>Datum odeslání:</bold> {{date}}',
        recordYourVaultID: 'Zapamatujte si tyto informace pro přihlášení',
        successInformation: 'Více informací',
        successMessage:
          'Vaše zpráva byla odeslána a je připravena k prohlížení. Všechny přiložené soubory, které vyžadují pozornost, budou po přihlášení označeny. Přihlašte se níže pro zobrazení aktualizací zpráv a posílání zpráv svému správci případů.',
        successSanitationMessage:
          'Uložte si kopii pro své záznamy a své Vault-ID uchovávejte v bezpečí - budete ho potřebovat k přístupu k aktualizacím a k odesílání zpráv svému správci případu.',
        successSanitationTagline:
          'Vaše zpráva byla odeslána a bezpečně uložena.',
        successThankYou: 'Děkujeme za váš report!',
        viewReport: 'Zobrazit zprávu',
      },
      Time: {
        approximateDescription:
          'Pamatujete si přibližný čas, kdy k události došlo?',
        approximatePlaceholder: 'Příklad: dopoledne, odpoledne',
        description: 'Pamatujete si čas, kdy se událost odehrála?',
        header: 'V kolik hodin k ní došlo?',
        invalidTime: 'Čas musí být uveden ve formátu HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Změnit heslo',
        closeDialog: 'Zavřít okno',
        logout: 'Odhlásit se',
        messageSettings: 'Nastavení zpráv',
        userSettings: 'Uživatelská nastavení',
      },
      Witnesses: {
        description:
          'Řekli jste o tom někomu jinému nebo viděl někdo, co se stalo?',
        header: 'Nějací svědci?',
        placeholder: 'Začněte psát…',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Odeslat zprávu',
        title: 'Správce případů',
        translationHeader: 'Dozvědět se více o automatických překladech',
      },
      ReportCard: {
        addEvidence: 'Přidejte důkazy',
        submissionModeVia: 'přes {{submissionMode}}',
        viewEvidence: 'Zobrazit důkazy',
      },
      ReportList: {
        yourReports: 'Vaše zprávy',
      },
      ReportingActivate: {
        buttonText: 'Pokračovat',
        description:
          'Pokud vás vaše organizace zaregistrovala pro účet, pošleme vám e-mail s instrukcemi k dokončení nastavení.',
        emailInput: 'E-mail',
        header: 'Zadejte svůj pracovní e-mail',
        successAccount:
          'Pokud vás vaše organizace zaregistrovala pro účet, pošleme vám e-mail s instrukcemi k dokončení nastavení.',
        successEmail:
          'Pokud to nevidíte okamžitě, počkejte prosím několik minut a obnovte svou e-mailovou schránku.',
        successHeading: 'Děkuji',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Přidejte důkazy do své zprávy',
        descriptionText:
          'Přidání souborů jako důkaz může podpořit efektivitu řešení vaším správcem případů. Prosím zvažte obsah souboru (včetně metadat souboru), pokud si přejete zůstat anonymní, a respektujte práva ostatních jedinců a platné zákony. Pro více informací se prosím podívejte na tento <a>help article</a>',
        emptyMessage: 'Nebyly nahrány žádné další důkazy',
      },
      ReportingChangePassword: {
        back: 'Zpět',
        description:
          'Vytvořte silné heslo pro zabezpečení vašeho účtu. Začněte psát a pod ním uvidíte pokyny.',
        errorToast: 'Nelze vytvořit heslo, neplatný token.',
        header: 'Změnit heslo',
        incorrectCurrentPassword:
          'Současné heslo je špatně. Zkontrolujte ho a zkuste to znovu.',
        invalidToken: 'Neplatný token',
        passwordUpdated: 'Heslo aktualizováno',
        passwordUpdatedDescription:
          'Vaše heslo bylo úspěšně aktualizováno. Děkujeme, že jste učinili tento krok k zajištění bezpečnosti vašich dat!',
        passwordUsedBefore: 'Opětovné použití hesla není povoleno',
        passwordUsedBeforeDescription:
          'Pro vaši bezpečnost nemůžete znovu použít žádné z vašich posledních šesti hesel. Vyberte si prosím nové, jedinečné heslo, abyste udrželi svůj účet v bezpečí, a zkuste to znovu.',
        toastDescription:
          'Vaše heslo bylo úspěšně aktualizováno. Děkujeme, že jste udělali tento krok k zajištění bezpečnosti vašich dat!',
        toastMessage: 'Heslo aktualizováno',
        updatePasswordCTA: 'Aktualizovat heslo',
      },
      ReportingConnect: {
        cancelButton: 'Zrušit',
        connectButton: 'Připojit',
        disclaimer:
          'Připojení vašeho účtu Slack k vašemu účtu Vault zajišťuje bezpečné a soukromé spojení.<br /><br />Po připojení můžete hlásit nesprávné chování nebo položit otázku přímo v Slacku. Vždy budete mít možnost nahlásit anonymně. Vaše soukromí a bezpečnost jsou naše nejvyšší priority.',
        heading:
          'Vault Platform žádá o povolení přístupu k vašemu {{organisationName}} Slack účtu',
        listHeading: 'Co bude Vault schopen dělat?',
        permissionIdentity: {
          extraInfo:
            'Vault bude mít schopnost zobrazit identitu vašeho uživatele na Slacku.',
          heading: 'Zobrazit informace o totožnosti uživatele',
        },
        permissionNotifications: {
          extraInfo:
            'Vault bude schopen vám posílat upozornění na váš Slack účet týkající se jakýchkoli aktualizací odeslané zprávy nebo otázky.',
          heading: 'Posílat vám oznámení',
        },
        permissionOverview: {
          extraInfo: 'Vault zobrazí přehled všech příspěvků na úvodní stránce',
          heading: 'Přehled příspěvků',
        },
        permissionSubmitReport: {
          extraInfo:
            'Toto udělí Vault oprávnění odeslat zprávu nebo položit otázku přímo vaší organizaci z Slacku.',
          heading: 'Podat zprávu nebo otázku jménem Vault',
        },
        successfulConnectionDescription:
          'Váš účet Vault a Slack jsou nyní propojeny. Nyní můžete zavřít tuto kartu a vrátit se do Slacku.',
        successfulConnectionHeading: 'Úspěšně připojeno',
        unsuccessfulConnectionDescription:
          'Něco se pokazilo. Prosím zavřete tuto kartu a vraťte se zpět do Slacku a zkuste to znovu.',
        unsuccessfulConnectionHeading: 'Připojení selhalo',
      },
      ReportingForgotPassword: {
        description:
          'Zadejte e-mailovou adresu spojenou s vaším účtem a my vám pošleme odkaz pro resetování vašeho hesla.',
        heading: 'Zapomenuté heslo',
        invalidTokenError: 'Nelze vytvořit heslo, neplatný token.',
        passwordReuseError: 'Opětovné použití hesla není povoleno',
        passwordReuseErrorDescription:
          'Pro vaši bezpečnost nemůžete znovu použít žádné z vašich posledních šesti hesel. Vyberte si prosím nové, jedinečné heslo pro zabezpečení vašeho účtu a zkuste to znovu.',
        sendLink: 'Poslat odkaz pro resetování',
        sendLinkFailure: 'Něco se pokazilo',
        sendLinkFailureDescription:
          'Vraťte se zpět do <a>Reporter Hub</a> a zkuste to znovu. Pokud problém přetrvává, kontaktujte nás na <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Odkaz pro resetování hesla odeslán',
        sendLinkSuccessDescription:
          'Poslali jsme odkaz pro obnovení hesla na {{email}}',
        updatePasswordSuccess: 'Heslo aktualizováno',
        updatePasswordSuccessDescription:
          'Vaše heslo bylo úspěšně aktualizováno. Děkujeme, že jste učinili tento krok k zajištění bezpečnosti vašich dat!',
      },
      ReportingLogin: {
        accountFrozen: 'Účet je zmražen',
        accountLocked:
          'Přihlášení bylo pokuseno příliš mnohokrát nesprávně. Účet je uzamčen až na 1 hodinu. Resetování hesla není během této doby možné.',
        accountLockedPermanently:
          'Váš účet byl uzamčen. Použijte obnovení hesla pro znovuzískání přístupu nebo se obraťte na správce systému pro další pomoc.',
        createAccountCTA: 'Zaregistrujte se na účet',
        currentPassword: 'Současné heslo',
        emailLabel: 'Váš email',
        forgotPassword: 'Zapomněli jste heslo?',
        loginButton: 'Přihlásit se',
        newPasswordPlaceholder: 'Nové heslo',
        passwordFailMessage:
          'Vraťte se zpět do aplikace Vault v Slacku a zkuste to znovu. Pokud problém pokračuje, obraťte se na nás na techsupport@vaultplatform.com',
        passwordFailTitle: 'Něco se pokazilo',
        passwordLabel: 'Vaše heslo',
        passwordPlaceholder: 'Zadejte své heslo',
        passwordResetRequired: 'Je nutné resetovat heslo',
        passwordSuccessfullySetMessage:
          'Vraťte se zpět do aplikace Vault v Slacku a ověřte se pomocí svého nového hesla, abyste mohli pokračovat tam, kde jste skončili.',
        passwordSuccessfullySetTitle: 'Heslo úspěšně nastaveno',
        reenterPlaceholder: 'Zadejte heslo znovu',
        title: 'Zpravodajské centrum',
        tooltip:
          'Pokud jste pro aplikaci Vault ještě nenastavili heslo, postupujte podle pokynů zde. Pokud jste zapomněli své heslo, použijte odkaz "Zapomenuté heslo" níže.',
        usernameLoginFailed:
          'Přihlášení se nezdařilo, uživatelské jméno nebo heslo je nesprávné',
      },
      ReportingReset: {
        failureDescription:
          'Vraťte se zpět do aplikace Vault v Slacku a zkuste to znovu. Pokud problém přetrvává, kontaktujte nás na <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Něco se pokazilo',
        successDescription:
          'Vraťte se zpět do aplikace Vault v Slacku a ověřte se svým novým heslem, abyste mohli pokračovat tam, kde jste skončili.',
        successHeading: 'Heslo úspěšně nastaveno',
      },
      noReports: {
        description:
          'Všechny odeslané zprávy se zobrazí zde. Dozvědět se více o způsobech, jak můžete odeslat zprávu v',
        descriptionHelpArticle: 'tento nápovědný článek',
        errorDescription:
          'Máme potíže s načítáním vašich zpráv. Prosím, zkuste obnovit stránku.',
        errorDescriptionSecondary:
          'Pokud to nefunguje, kontaktujte nás prosím na',
        errorTitle: '⚠️ Jejda, něco se pokazilo',
        title: 'Zatím nemáte žádné zprávy',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Povolte automatické překlady a čtěte všechny zprávy z reportů ve svém preferovaném jazyce. Přeložený jazyk je založen na jazyce, který je vybrán na vašem zařízení.',
          autoTranslationDescription2:
            'Můžete přepínat mezi přeloženým a původním jazykem v každém chatu.',
          autoTranslationTitle: 'Povolte automatické překlady pro zprávy zpráv',
          header: 'Nastavení zpráv',
          subHeader: 'Nastavte zobrazení zpráv',
        },
        notificationSettings: {
          emailDescription:
            'Obdržet emailové upozornění na důležité aktualizace vašich zpráv',
          emailTitle: 'Emailové upozornění',
          header: 'Nastavení oznámení',
          subHeader: 'Nastavte, jak chcete přijímat oznámení',
        },
        title: 'Nastavení',
        updatedSettingsFailure: 'Nepodařilo se aktualizovat vaše nastavení',
        updatedSettingsSuccess: 'Úspěšně jste aktualizovali své nastavení',
      },
    },
    validators: {
      passwordLength: 'Heslo musí mít alespoň 9 znaků',
      passwordLowercase: 'Heslo musí obsahovat alespoň 1 malé písmeno',
      passwordMissMatch: 'Heslo a potvrzovací pole se musí shodovat.',
      passwordNumeric: 'Heslo musí obsahovat alespoň 1 číslo',
      passwordUppercase: 'Heslo musí obsahovat alespoň 1 velké písmeno',
    },
    validatorsNew: {
      passwordLength: 'Mezi 10 a 30 znaky',
      passwordLowercase: 'Alespoň jedno malé písmeno',
      passwordMissMatch: 'Hesla se neshodují',
      passwordNumeric: 'Alespoň jedno číslo',
      passwordSpecialCharacter: 'Alespoň jeden speciální znak',
      passwordUppercase: 'Minimálně jedno velké písmeno',
    },
  },
};

export default translations;
